document.addEventListener('click', function (e) {
    if (e.target && e.target.classList.contains('videoPlaceholder')) {
        var clickedImage = e.target;
        var ytVideoContainer = document.createElement('div');
        ytVideoContainer.className = 'yt-video-container';

        var ytVideoWrapper = document.createElement('div');
        ytVideoWrapper.className = 'yt-video-wrapper';

        var closeBtn = document.createElement('button');
        closeBtn.className = 'close-btn';
        closeBtn.innerText = 'X';

        // Create a new iframe element
        var videoFrame = document.createElement('iframe');
        videoFrame.setAttribute('allow', 'autoplay');
        videoFrame.setAttribute('frameborder', '0');
        videoFrame.setAttribute('allowfullscreen', '');

        // Get the video ID and platform from the data attributes of the clicked element
        var videoId = clickedImage.getAttribute('data-vid');
        var platform = clickedImage.getAttribute('data-platform');

        // Set the video source based on the platform
        if (platform === 'youtube') {
            videoFrame.src = 'https://www.youtube.com/embed/' + videoId + '?autoplay=1';
        } else if (platform === 'vimeo') {
            videoFrame.src = 'https://player.vimeo.com/video/' + videoId + '?autoplay=1';
        } else {
            console.error('Unsupported platform:', platform);
            return;
        }

        // Clear existing iframes and append the new iframe
        ytVideoWrapper.appendChild(videoFrame);
        ytVideoWrapper.appendChild(closeBtn);
        ytVideoContainer.appendChild(ytVideoWrapper);
        document.body.appendChild(ytVideoContainer);

        ytVideoContainer.style.display = 'flex';

        // Close video container on close button click
        closeBtn.addEventListener('click', function () {
            ytVideoContainer.style.display = 'none';
            ytVideoContainer.remove();
        });

        // Close video container on click outside
        ytVideoContainer.addEventListener('click', function (event) {
            if (event.target === ytVideoContainer) {
                ytVideoContainer.style.display = 'none';
                ytVideoContainer.remove();
            }
        });
    }
});
